import React, { useState } from 'react';

import { Modal, TopicsSelect } from '../';

const ModalTopic = ({
  isOpen,
  onClose,
  category,
  onSave
}) => {

  const initialTopicData = { _id: '', name: '', descr: '' };
  const initialErrorObj = {topic:false,topicSelect:false}
  const [topicData, setTopicData] = useState({ ...initialTopicData });
  const [isCustom, setIsCustom] = useState(false);
  const [errorObj, setErrorObj] = useState(initialErrorObj);

  const name = category.category;
  const { topics } = category;


  const onSaveLocal = () => {
    const {_id, descr } = topicData;
    let {name=''} = topicData;
    name=name.trim();
    setErrorObj({...initialErrorObj});
    let ok=true;
    if(!name) {
      if(isCustom)
        setErrorObj({...errorObj,topic:<small className="error-msg">Empty topic is no allowed!</small>});
      else 
        setErrorObj({...errorObj,topicSelect:<small className="error-msg">Choose a topic!</small>});

      ok=false;
    }

    
    if(!ok) return ok;

    onSave({_id, topic: name, descr });
    clearState();
  }


  const onChange = (prop) => {
    return ({ target: { value } }) => {
      const newData = { ...topicData, [prop]: value }
      setTopicData(newData);
    }
  }

  // console.log('topicdata', topicData);

  const clearState = () => {
    setIsCustom(false);
    setTopicData({ ...initialTopicData });
  }

  const onCancel = () => {
    clearState();
    onClose();
  }

  const onChangeTopic = (value) => {
    console.log('value INITIAL',value);
    setErrorObj({...initialErrorObj});
    if (value === 'CUSTOM') {
      setIsCustom(true);
      // onChange('name')({target:{value:''}});
      setTopicData({ ...initialTopicData });
    } else if (!value) {
      setErrorObj({...errorObj,topicSelect:<small className="error-msg">Choose a topic!</small>});
      clearState();
    } else {
      setIsCustom(false);

      /* Ex:
        _id: "5e13b42c68cca74137489def"
        name: "Population"
        descr: "Total popula"
      */

      setTopicData({ ...value });
    }

  }

  let topicCustomHtml = false, topicDescrReadOnly = true;
  if (isCustom) {
    topicCustomHtml = (
      <div className="form-group">
        <label>Custom Topic</label>
        <input className="textfield1" type="text" onChange={onChange('name')} value={topicData.name} />
        {errorObj.topic}
      </div>
    )
    topicDescrReadOnly = false;
  }
  const topicDescrHtml = <input className="textfield1" readOnly={topicDescrReadOnly} type="text" onChange={onChange('descr')} value={topicData.descr} />;

  return (
    <Modal isOpen={isOpen} onClose={onCancel} className="modal-content-default add-topic-modal">
      <div className="font-color2">
        <h3>{name} / <span>New Topic</span></h3>
        <h4>Available Topics:
          <TopicsSelect onChange={onChangeTopic} currentTopics={topics} />
          <small>Select a topic or create your own by choosing "CUSTOM TOPIC"</small>
          {errorObj.topicSelect}
        </h4>
        <div className="add-topic-modal-descr">
          {topicCustomHtml}
          <div className="form-group">
            <label>Description</label>
            {topicDescrHtml}
          </div>
        </div>
        <div className="modal-controls">
          <button className="btn btn-default-cancel" onClick={onCancel} type="button">Cancel</button>
          <button className="btn btn-default-ok" onClick={onSaveLocal} type="button">Save</button>
        </div>
      </div>
    </Modal>
  )
}

export default ModalTopic;